<template>
  <div class="app aside-menu-show">
    <aside class="aside-menu">
      <CRow
        class="nav nav-tabs pl-md-5 pt-md-3 mb-4 mb-md-0 mb-lg-0 mb-xl-0"
        role="tablist"
      >
        <CCol
          :class="activeTab == 'tab-chart' ? 'active' : null"
          class="nav-item"
          sm="2"
          xl="1"
          @click="changeTab('tab-chart')"
        >
          <span>{{
              $t("project.label_project_resource_situation_chart")
            }}</span>
        </CCol>
        <CCol
          :class="activeTab == 'tab-list' ? 'active' : null"
          class="nav-item mb-3 mb-md-0"
          sm="4"
          xl="2"
          @click="changeTab('tab-list')"
        >
          <span>{{ $t("project.label_project_resource_situation_list") }}</span>
        </CCol>
      </CRow>
      <!-- Tab panes-->
      <div class="tab-content">
        <router-view
          :search-data="searchData"
          @resetForm="resetForm"
          @updateSearchData="updateSearchData"
          @updateSearchDataDate="updateSearchDataDate"
          @updateSearchDataDivision="updateSearchDataDivision"
          @updateSearchDataInfo="updateSearchDataInfo"
          @send-search-data="onHandleFilterData"
        />
      </div>
    </aside>
  </div>
</template>

<script>
import {CChartPie} from "@coreui/vue-chartjs";
import {mapActions, mapGetters} from "vuex";
import moment from "moment";
import Pagination from '../../components/Common/Pagination.vue';
import DatePicker from 'vue2-datepicker';
import ResourceOverview from "./ProjectResource/ResourceOverview";
import ResourceEmployees from "./ProjectResource/ResourceEmployees";

export default {
  name: "Resource",
  metaInfo() {
    return {
      title: this.$t("bread_crumb.project.resource"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  components: {
    ResourceEmployees,
    CChartPie,
    Pagination,
    DatePicker,
    ResourceOverview
  },
  data() {
    return {
      activeTab: "tab-chart",
      searchData: {
        info: "",
        footCode: 0,
        division: 0,
        status: 0,
        startDate: '',
        endDate: '',
        itemsPerPage: 10,
        skill: 0,
        oldFootCode: 0
      },
      page: 1,
      currentDate: new Date(),
    };
  },
  computed: {
    url() {
      return this.$route.path;
    }
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    ...mapActions("commons", ["getCommonsData"]),

    async changeTab(name) {
      this.setLoading(true);
      try {
        this.activeTab = name;
        if (this.activeTab === 'tab-list') {
          if (localStorage.getItem('search_condition')) {
            localStorage.removeItem('search_condition');
          }
          this.searchData.info = "";
          this.searchData.footCode = 0;
          this.searchData.division = 0;
          this.searchData.status = 0;
          this.searchData.skill = 0;
          this.$router.push({name: 'resource-employees'})
          await this.getLists(this.page);
          this.getStartEndDate();
        } else {
          this.$router.push({name: 'resource-overview'})
        }
        this.setLoading(false);
      } catch {
        this.setLoading(false);
      }
    },

    async onHandleFilterData(data) {
      this.setLoading(true);
      if (localStorage.getItem('search_condition')) {
        localStorage.removeItem('search_condition');
      }
      this.$router.push({name: 'resource-employees'})
      // this.$store.dispatch("commons/getDivisionByFoot", data.query.footCode);
      this.searchData.oldFootCode = data.query.footCode;
      this.getStartEndDate();
      this.searchData = {
        ...this.searchData,
        ...data.query,
      }
      console.log(this.searchData);
      this.page = 1;
      // let query = {
      //   start_date: this.searchData.startDate,
      //   end_date: this.searchData.endDate,
      //   skill: this.searchData.skill,
      //   ...data.query,
      //   page: this.page,
      //   employee_info: null
      // }
      // await this.$store.dispatch("project/listResourceSituations", query);
      localStorage.setItem('search_condition', JSON.stringify(this.searchData));
      this.setLoading(false);
    },
    getStartEndDate() {
      let currentDate = new Date();
      this.searchData.startDate = moment().subtract(7, 'd').format("DD/MM/YYYY");
      this.searchData.endDate = moment().format("DD/MM/YYYY");
    },
    updateSearchDataInfo() {
      this.searchData.info = this.searchData.info.trim();
    },
    updateSearchDataDivision(division) {
      this.searchData.division = division;
    },
    updateSearchDataDate(date) {
      this.searchData.startDate = date.startDate;
      this.searchData.endDate = date.endDate;
    },
    updateSearchData(data) {
      this.searchData = data.searchData;
    },
    resetForm(form) {
      this.searchData.info = form.info;
      this.searchData.division = form.division;
      this.searchData.status = form.status;
      this.searchData.skill = form.skill;
      this.searchData.footCode = form.footCode;
      localStorage.setItem('search_condition', JSON.stringify(this.searchData));
    },
  },
  async created() {
    if (this.$route.path.includes('resource-employees')) {
      this.activeTab = 'tab-list';
    }
    if (this.$route.path.includes('resource-overview')) {
      this.activeTab = 'tab-chart';
    }
    await this.getStartEndDate();
  },
  watch: {
    currentDate(value) {
      this.searchData.startDate = moment(value).startOf("isoWeek").format("DD/MM/YYYY");
      this.searchData.endDate = moment(value).startOf("isoWeek").add(6, "day").format("DD/MM/YYYY");
    },
    url(value) {
      if (value.includes('resource-employees')) {
        this.activeTab = 'tab-list';
      } else if (value.includes('resource-overview')) {
        this.activeTab = 'tab-chart';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.aside-menu-show {
  background-color: #FFFFFF;
}

.aside-menu {
  margin-left: 0px;
}

.nav-tabs {
  border: none;
  font-size: 1rem;
}

.nav-item {
  color: #858585;
  cursor: pointer;
  padding: 0px;
}

.nav-item.active span {
  color: #032641;
  display: inline-block;
  border-bottom: 2px solid black;
  padding-bottom: 2px;
  font-weight: bold;
}

.nav-item.active span {
  border-bottom: 2px solid #3488EB;
}

@media screen and (max-width: 1300px) {
  .aside-menu {
    margin-left: 30px;
  }
}

@media screen and (max-width: 767px) {
  .aside-menu {
    margin-left: 0;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .aside-menu {
    margin-left: 0;
  }
}

.container-fluid {
  padding: 0;
}

</style>
